const subscriptions :{[x:string]:{callback:Function}[]} = {};

export function publish( topic :string,  ... args :any[]) {
  if( !subscriptions[ topic ] ) {
    return;
  }
  subscriptions[topic].forEach(sub=>sub.callback.apply(sub,args))
}

export function subscribe( topic:string, callback:Function|{callback:Function}) {
  var topics = topic.split( /\s/ );
  if(topics.length>1){
    for(var i=0;i<topics.length;i++){
      subscribe(topics[i],callback);
    }
    return;
  }
  const subscription = typeof callback==='function'?{callback}:callback;
  if(subscriptions[topic]===undefined){
    subscriptions[topic] = []
  }
  subscriptions[topic].push(subscription)
}

export function unsubscribe( topic:string, callback:Function|{callback:Function}) {
  var topics = topic.split( /\s/ );
  if(topics.length>1){
    for(var i=0;i<topics.length;i++){
      unsubscribe(topics[i],callback);
    }
    return;
  }
  const subscription = typeof callback==='function'?{callback}:callback;
  subscriptions[topic] = subscriptions[topic].filter(sub=>sub.callback!==subscription.callback)
}